import { useState, useEffect } from 'react';
import { fetchItems } from '../services/portfolioApi';

export function usePortfolio<T>(type: string) {
  const [data, setData] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchItems(type)
      .then((items) => setData(items as T[]))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [type]);

  return { data, loading, error };
}
